import Multifamily from "components/multifamily/multifamily"
export default Multifamily